module.exports = __webpack_public_path__ + "img/house.4862f8d3.svg";